import { useCallback, useEffect, useState } from 'react';
import { usePermissions } from 'react-admin';
import { fetchPendingApplicationsSummary } from '../services/pendingApplicationsService';
import { subscribePendingApplicationsChanged } from '../services/pendingApplicationsEvents';

const canReviewApplications = (permissions) =>
  permissions?.crole === 'admin' || permissions?.crole === 'operator';

export const usePendingApplicationsSummary = () => {
  const { permissions } = usePermissions();
  const [summary, setSummary] = useState({
    total: 0,
    byType: { venue: 0, organisationCompany: 0, salesAgent: 0 },
    items: [],
  });

  const load = useCallback(async () => {
    if (!canReviewApplications(permissions)) {
      setSummary({
        total: 0,
        byType: { venue: 0, organisationCompany: 0, salesAgent: 0 },
        items: [],
      });
      return;
    }
    try {
      const data = await fetchPendingApplicationsSummary();
      setSummary({
        total: data?.total || 0,
        byType: data?.byType || {
          venue: 0,
          organisationCompany: 0,
          salesAgent: 0,
        },
        items: data?.items || [],
      });
    } catch {
      setSummary({
        total: 0,
        byType: { venue: 0, organisationCompany: 0, salesAgent: 0 },
        items: [],
      });
    }
  }, [permissions]);

  useEffect(() => {
    load();
    if (!canReviewApplications(permissions)) return undefined;
    const timer = setInterval(load, 60000);
    const unsubscribe = subscribePendingApplicationsChanged(load);
    return () => {
      clearInterval(timer);
      unsubscribe();
    };
  }, [load, permissions]);

  return { summary, reload: load };
};

export const usePendingApplicationCount = (companyType) => {
  const { summary } = usePendingApplicationsSummary();
  return summary.byType?.[companyType] || 0;
};
